import lottie from 'lottie-web';
import animation from '@CS/utils/Lottie';
import { useRef, useEffect } from 'react';
import CSS from './LottieAnimation.module.css';
import type { AnimationItem } from 'lottie-web';
import type { AnimationConfig } from '@CS/utils/Lottie';

type LottieAnimationProps = {
  onCreate?: (item: AnimationItem) => void;
  animationData: Record<string, unknown>;
  data?: AnimationConfig;
  path?: string;
};

export const LottieAnimation = ({
  animationData,
  onCreate,
  data,
  path
}: LottieAnimationProps) => {
  const animationContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = animationContainer.current as Element;

    const item = animation({
      ...(path && { path }),
      ...(data && data),
      animationData,
      container
    });

    onCreate?.(item);
    return () => lottie.destroy();
  }, []);

  return <div ref={animationContainer} className={CSS.animationContainer} />;
};
